import React, { Fragment, Suspense, useMemo } from "react";
import { useCategoryContent } from "../../../Pregrine/RootComponents/Category/useCategoryContent";
import classes from "./category.module.css";
import GalleryShimmer from "../../Gallery/gallery.shimmer";
import CustomPagination from "../../CustomPagination/CustomPagination";
import Gallery from "../../Gallery/gallery";
import ProductSort, { ProductSortShimmer } from "../../ProductSort";
import SortedByContainer, {
  SortedByContainerShimmer,
} from "../../SortedByContainer";
import { FilterSidebarShimmer } from "../../FilterSidebar";
import FilteredWrapper from "../../FilterSidebar/FilteredWrapper";
import FilterTile from "../../FilterSidebar/FilterTile";
import classNames from "classnames";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs";
import CompareWidget from "../../../components/CompareWidget/CompareWidget";
const FilterSidebar = React.lazy(() => import("../../FilterSidebar"));
const FilterModal = React.lazy(() => import("../../FilterModal/FilterModal"));
const FilterTileSidebar = React.lazy(() =>
  import("../../FilterSidebar/FilterTileSidebar")
);
import CategoryBanner from "../../CategoryBanner/CategoryBanner";

const CategoryContent = (props) => {
  const {
    categoryId,
    data,
    isLoading,
    pageNumberParam,
    sortProps,
    pageSize,
    setFilters,
    filters,
    initialFilter,
    categorySidebarData,
    searchInput,
    setSearchInput,
    handleInputChange,
    megaMenuLoading,
    loadingState,
    categoryName: catName,
  } = props;

  const [currentSort] = sortProps;

  const talonProps = useCategoryContent({
    categoryId,
    data,
    pageSize,
    filters,
  });

  const {
    filtersListing,
    items,
    totalCount,
    totalPagesFromData,
    setFilterModal,
    filterModal,
    setSelectedFilters,
    selectedFilters,
    filterTileSidebar,
    setFilterTileSidebar,
    categoryNames,
    setCategoryNames,
    categoryImage,
    ConfigData,
  } = talonProps;

  const shouldShowSortShimmer = isLoading;

  const filtersModal = categorySidebarData && (
    <Suspense fallback={null}>
      <FilterModal
        setFilterModal={setFilterModal}
        filterModal={filterModal}
        categorySidebarData={categorySidebarData || []}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        filtersListing={filtersListing}
        handleInputChange={handleInputChange}
      />
    </Suspense>
  );

  const filtersTileModal = filtersListing && filterTileSidebar && (
    <Suspense fallback={null}>
      <FilterTileSidebar
        categoryId={categoryId}
        filtersListing={filtersListing}
        setFilters={setFilters}
        filters={filters}
        setSelectedFilters={setSelectedFilters}
        selectedFilters={selectedFilters}
        initialFilter={initialFilter}
        setFilterTileSidebar={setFilterTileSidebar}
        searchInput={searchInput}
      />
    </Suspense>
  );

  const sidebar =
    megaMenuLoading && !categorySidebarData ? (
      <FilterSidebarShimmer />
    ) : (
      <Suspense fallback={<FilterSidebarShimmer />}>
        <FilterSidebar
          categorySidebarData={categorySidebarData || []}
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          filtersListing={filtersListing}
          handleInputChange={handleInputChange}
          categoryName={catName}
        />
      </Suspense>
    );

  const maybeSortButton = shouldShowSortShimmer ? (
    <ProductSortShimmer />
  ) : (
    <ProductSort sortProps={sortProps} />
  );

  const maybeSortContainer = shouldShowSortShimmer ? (
    <SortedByContainerShimmer />
  ) : (
    <SortedByContainer currentSort={currentSort} />
  );

  const content = useMemo(() => {
    if (!totalPagesFromData && loadingState === "idle") {
      const emptyArr = new Array(6).fill(null);
      return <GalleryShimmer items={emptyArr} />;
    }
    if (loadingState === "loading" || loadingState === "idle") {
      const emptyArr = new Array(6).fill(null);
      return <GalleryShimmer items={emptyArr} />;
    }
    if (totalPagesFromData && loadingState === "finished") {
      return (
        <Fragment>
          <section className={classes.gallery}>
            <Gallery items={items} categoryNames={categoryNames} />
          </section>
          <div className={classes.pagination}>
            {totalPagesFromData && (
              <CustomPagination
                pageNumberParam={pageNumberParam}
                pageSize={pageSize}
                totalCount={totalCount}
                totalPagesFromData={totalPagesFromData}
              />
            )}
          </div>
        </Fragment>
      );
    }
    if (!totalPagesFromData && loadingState === "finished") {
      return <span>No Product Found</span>;
    }
  }, [
    loadingState,
    items,
    pageNumberParam,
    pageSize,
    totalCount,
    totalPagesFromData,
  ]);

  const newFilterCategoryIds =
    ConfigData?.new_filter_catogory?.split(",").map((id) => Number(id)) || [];
  return (
    <Fragment>
      {window.innerWidth < 500 ? (
        categoryImage?.category_image_mobile ? (
          <CategoryBanner BannerData={categoryImage} />
        ) : (
          <hr />
        )
      ) : categoryImage?.category_icon ? (
        <CategoryBanner BannerData={categoryImage} />
      ) : (
        <hr />
      )}

      <Breadcrumbs setCategoryNames={setCategoryNames} />

      {filtersModal}
      {filtersTileModal}

      <section
        className={classNames(classes.section_gap, "productlist")}
        id="productlist"
      >
        <div className="search-section">
          <div className="container-fluid container-xl">
            <div
              className={classNames(
                "row main-content ml-md-0",
                classes.container
              )}
            >
              <div
                className={classNames(
                  classes.sidebar,
                  "col-md-3 px-0 is-affixed"
                )}
              >
                {sidebar}
              </div>
              <div className="content col-md-9">
                <div className={classes.filtersAndMore}>
                  {selectedFilters && (
                    <FilteredWrapper
                      setSelectedFilters={setSelectedFilters}
                      selectedFilters={selectedFilters}
                      filtersListing={filtersListing}
                    />
                  )}
                  {filtersListing && filtersListing.length ? (
                    <div
                      className={classNames(
                        "d-flex justify-content-between border-bottom align-items-start mb-2",
                        classes.filtermain
                      )}
                    >
                      <FilterTile
                        categoryId={categoryId}
                        filtersListing={filtersListing}
                        setFilters={setFilters}
                        filters={filters}
                        setSelectedFilters={setSelectedFilters}
                        selectedFilters={selectedFilters}
                        initialFilter={initialFilter}
                        searchInput={searchInput}
                      />
                      {!newFilterCategoryIds?.includes(categoryId) ? (
                        <div className={classes["filters-actions"]}>
                          <div className={classes.filterBtnWrapper}>
                            <button
                              className="btn filter-btn"
                              onClick={() => setFilterModal(true)}
                            >
                              Show Categories
                            </button>
                          </div>
                          {maybeSortButton}
                          {maybeSortContainer}
                        </div>
                      ) : null}

                      <div
                        className={
                          !newFilterCategoryIds?.includes(categoryId)
                            ? classes.filterTile
                            : classes.filterTileSpecific
                        }
                      >
                        <button
                          onClick={() => setFilterTileSidebar(true)}
                          style={{ padding: "6px 12px" }}
                        >
                          Show Filters
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="placeholder-glow"
                      style={{ backgroundColor: "transparent" }}
                    >
                      <span
                        className={classNames(
                          classes.filterTilePlaceholder,
                          "placeholder"
                        )}
                        style={{ backgroundColor: "transparent" }}
                      />
                    </div>
                  )}
                </div>
                {content}
              </div>
            </div>
          </div>
        </div>
      </section>
      <CompareWidget />
    </Fragment>
  );
};

export default React.memo(CategoryContent);
